import { render, staticRenderFns } from "./df-page-account-activation.vue?vue&type=template&id=091d7d82"
import script from "./df-page-account-activation.ts?vue&type=script&lang=js&external"
export * from "./df-page-account-activation.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports